import { Router } from "@angular/router";
import { EnumService } from "./../../shared/services/enum.service";
import { Component, OnInit } from "@angular/core";
import { ProductService } from "../../shared/services/product.service";
import { CartService } from "../../shared/services/cart.service";
import { CartItem } from "src/app/modals/cart-item";
import { Product } from "src/app/modals/product.model";
import { BanerItemsIncio } from "src/app/modals/baner-items-incio";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { EcommService } from "src/app/services/ecomm.service";

@Component({
  selector: "app-home-five",
  templateUrl: "./home-five.component.html",
  styleUrls: ["./home-five.component.sass"],
})
export class HomeFiveComponent implements OnInit {
  products: Product[] = [];
  banerItemInicio: any;
  shoppingCartItems: any;

  // public slides = [
  //   { title: 'Huge sale', subtitle: 'Up to 70%', image: 'https://novaplaza.pe/img/promociones/banner-bicicletas-intense-devices-3.jpg' },
  //   { title: 'Biggest discount', subtitle: 'Check the promotion', image: 'assets/images/carousel/banner2.jpg' },
  //   { title: 'Biggest sale', subtitle: 'Dont miss it', image: 'assets/images/carousel/banner3.jpg' },
  //   { title: 'Our best products', subtitle: 'Special selection', image: 'assets/images/carousel/banner4.jpg' },
  //   { title: 'Massive sale', subtitle: 'Only for today', image: 'assets/images/carousel/banner5.jpg' }
  // ];
  public slides: any[] = [];
  public discount: any[] = [];
  private loader: boolean = true;
  showMenuCat: boolean = true;
  // discount: any[] = [];
  constructor(
    private productService: ProductService,
    private cartService: CartService,
    private enumService: EnumService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private appHelper: EcommService,
  ) {}

  ngOnInit() {
    // window.scrollTo(0, 0);
    // this.appHelper.post("/").subscribe((res:any) => {
    //   console.log(res)
    //  })
    localStorage.removeItem("cart");
    localStorage.removeItem("cartItem");
    localStorage.removeItem("email");
    sessionStorage.removeItem("marca");

    this.spinner.show();
    this.cartService
      .getItems()
      .subscribe(
        (shoppingCartItems) => (this.shoppingCartItems = shoppingCartItems)
      );
    //#region Banners
    this.productService.getBanners().subscribe(
      (baner: any) => {
        // ////console.log(baner.itemsEcCat);
        // //console.log(baner)
        this.banerItemInicio = baner;
        this.banerItemInicio.itemsEC_Destacados.sort(function(a, b){return a.OrdenIEC - b.OrdenIEC})
        // console.log(baner)
        //#region items
        this.spinner.hide();
        this.productService.getProducts().subscribe(
          (product: Product[]) => {
            this.products.splice(0, this.products.length);
            this.products = product;
          },
          (error: any) => {
            this.spinner.hide();
          }
        );
        //#endregion
      },
      (error: any) => {
        this.spinner.hide();
      }
    );

    //#endregion
  }
  ngDoCheck() {
    document.title = "Novaplaza | Tecnología de nivel"
    let tamaño = window.innerWidth;
    // if (tamaño >= 730) {
    //   this.showMenuCat = true;
    // } else {
    //   this.showMenuCat = false;
    // }

  }
  irAProductos(item) {
    let paramCodigo = item.Codigo.length == 0 ? "0" : item.Codigo;
    if(sessionStorage.getItem("paramFilter") != null){
      let paramNomItem =  {
        param1: "",
        param2: "",
        param3: ""
      }
     sessionStorage.setItem("paramFilter",JSON.stringify(paramNomItem)) 
    }
    sessionStorage.setItem("marca","TODAS")
    if (item.idItem == null) {
      if (item.Marca.length == 0) {
        this.router.navigate(["/home/products", paramCodigo,0,0, "TODAS", 0,0,1]);
      } else {
        this.router.navigate(["/home/products", paramCodigo,0,0, item.Marca, 0,0,1]);
      }
    } else {
      this.router.navigate(["/home/product", item.idItem]);
    }
  }
}
